module.exports = __webpack_public_path__ + "media/images/area/popular/sapporo-17bc6a7a78fcdb929a1b6cbe49a2282c.jpg";